import { Loading } from '@common/index';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import dayjs from 'dayjs';
import styles from './index.module.scss';

export const History = <T extends {title: string, created_at: string} & Record<string, any>>({
    history,
    isLoadingHistory,
    onHistoryItemClick,
    headerTitle = 'History',
    emptyMessage = 'No history',
}: {
    history: T[];
    isLoadingHistory: boolean;
    onHistoryItemClick?: (item: T) => void;
    headerTitle?: string;
    emptyMessage?: string;
}) => {
    // 格式化日期为 "Friday, August 8, 2025" 格式
    const formatHistoryDate = (dateString: string) => {
        return dayjs(dateString).format('dddd, MMM D, YY [at] HH:mm');
    };
    return (
        <>
            <div className={styles.historyPopupHeader}>{headerTitle}</div>
            <div className={styles.historyList}>
                {isLoadingHistory ? (
                    <div className={styles.historyEmpty}>
                        <Loading size={16} />
                    </div>
                ) : history.length > 0 ? (
                    history.map((item) => (
                        <DropdownMenu.Item
                            key={item.id}
                            className={styles.historyItem}
                            onSelect={() => onHistoryItemClick?.(item)}
                        >
                            <div className={styles.historyItemTitle}>{item.title}</div>
                            <div className={styles.historyItemDate}>{formatHistoryDate(item.created_at)}</div>
                        </DropdownMenu.Item>
                    ))
                ) : (
                    <div className={styles.historyEmpty}>
                        {emptyMessage}
                    </div>
                )}
            </div>
        </>
    )
}